import { ErrorStateScheduleEnum } from '../../error-state-schedule.enum';

export enum PanelSettingsProductsResolverErrorStateEnum {
    GetProductsFailed = ErrorStateScheduleEnum.PanelSettingProductsResolverStatesStartIndex,
}
